// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company_logo {
  width: 190px;
  height: 44px;
  gap: 0px;
  opacity: 1 !important;
}

.cursor_pointer {
  cursor: pointer;
}

.navbar_bg {
  background-color: #f7f7f7;
}

.bg_button_color {
  background: #1b9075;
}

.disabled_button {
  background: #c3c7ca;
}

.text_color {
  color: #1b9075;
}

.p_info {
  width: 297px;
  height: 44px;
  gap: 0px;
  font-family: Lexend;
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
  text-align: center;
  margin: 0 auto;
  opacity: 1 !important;
}

input:focus {
  border-color: transparent;
  border: none;
  box-shadow: 0 0 0 1px #1b9075 !important;
}

textarea {
  border-color: transparent;
  border: none;
  box-shadow: 0 0 0 1px #1b9075 !important;
}

.marginTopNeg_8 {
  margin-top: -8rem;
}

.marginTopNeg_5 {
  margin-top: -3rem;
}

.mobile_code {
  height: 15rem;
  transform: translate(0px, 146px) !important;
  overflow: auto;
  position: absolute;
  width: 28%;
}

.mobile_code_list .active {
  background-color: #1b9075;
}

.mobile_code_list .active span {
  color: #fff;
}

.mobile_code_list li:hover {
  background-color: #1b9075;
}

.mobile_code_list li button:hover {
  color: #fff;
}

.form_error {
  color: #f32013;
  font-family: Manrope;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0 0.25rem;
}

.form_error_border {
  border: 1px solid #f32013;
}

.form_error_border_input {
  border: 1px solid #f32013;
  border-left: 0px !important;
}

.form_error_border_code {
  border: 1px solid #f32013;
  border-right: 0px !important;
}


/* common css for input fields */

.input_field {
  /* width: 350px;*/
  height: 58px;
  border-radius: 5px;
  /* border: 1px solid #1B9075; */
}

.input_placeholder {
  /* padding: 0.5rem; */
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  pointer-events: none;
  position: absolute;
  left: 0.5rem;
  top: 1rem;
  transition: 0.4s;
  opacity: 1;
  font-family: Lexend;
  font-size: 16px;
  font-weight: 300;
  line-height: 13.75px;
  text-align: left;
  color: #a1a8a6;

}

input:focus,
input:not(:placeholder-shown) {
  outline: none;
  /* border-color: #1b9075; */
}

input:focus+.input_placeholder,
input:not(:placeholder-shown)+.input_placeholder {
  opacity: 1;
  color: #1b9075;
  transform: scale(0.75) translateY(-65%) translateX(-20px);
}

/* for input note */
input:focus+.input_placeholder_note,
input:not(:placeholder-shown)+.input_placeholder_note {
  transform: scale(0.75) translateY(-65%) translateX(-40px);
}

/* for input service */
input:focus+.input_placeholder_servicetype,
input:not(:placeholder-shown)+.input_placeholder_servicetype {
  transform: scale(0.75) translateY(-65%) translateX(-24px);
}


/* for input area */
input:focus+.input_placeholder_area,
input:not(:placeholder-shown)+.input_placeholder_area {
  transform: scale(0.75) translateY(-65%) translateX(-38px);
}

/* for input house number */
input:focus+.input_placeholder_houseNumber,
input:not(:placeholder-shown)+.input_placeholder_houseNumber {
  transform: scale(0.75) translateY(-65%) translateX(-30px);
}

/* for input location */
input:focus+.input_placeholder_location,
input:not(:placeholder-shown)+.input_placeholder_location {
  transform: scale(0.75) translateY(-65%) translateX(-32px);
}

/* for input addresstype */
input:focus+.input_placeholder_addresstype,
input:not(:placeholder-shown)+.input_placeholder_addresstype {
  transform: scale(0.75) translateY(-65%) translateX(-26px);
}

.btn_primary {
  width: 100%;
  height: auto;
  border-radius: 9px;
  background: #1B9075;
  color: #fff;
  padding: 1rem;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
}

.btn_secondary {
  width: 100%;
  height: auto;
  border-radius: 9px;
  background: #E4EFEC;
  color: #1B9075;
  padding: 1rem;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
}

.btn_light {
  border: 1px solid #1B9075;
  width: auto;
  height: auto;
  padding: 6px 14px 6px 14px;
  border-radius: 10px;

  font-family: Lexend;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  color: #1B9075;
  background-color: #fff;
}

.first_head {
  font-family: Manrope;
  font-size: 24px;
  font-weight: 600;
  line-height: 32.78px;
  text-align: left;
}

.second_head {
  font-family: Manrope;
  font-size: 24px;
  font-weight: 600;
  line-height: 32.78px;
  text-align: left;
  color: #1B9075;
}

.addAddressBtnTxt {
  font-family: Manrope;
  font-size: 14px;
  font-weight: 600;
  line-height: 32.78px;
  text-align: left;
  color: #1B9075;
}

input[type="date"] {
  position: relative;
  background-repeat: no-repeat;
  background-position: right 2.75rem center;
  background-size: 16px 12px;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  background: transparent;
  bottom: 0;
  color: transparent;
  cursor: pointer;
  height: auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
}

input[type="date"]::after {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  width: 16px;
  height: 16px;
}

/* css for about us contact us and blog and other pages */

.bgColor {
  background: #1B9075;
}

.heading_text {
  font-family: Manrope;
  font-size: 24px;
  font-weight: 700;
  line-height: 32.78px;
  /* text-align: left; */
  color: #ffffff;
}

.content_text {
  font-family: Manrope;
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;
  color: #263238;
}

.heading_text1 {
  font-family: Manrope;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  text-align: left;
  color: #1B9075;
}

.content_text1 {
  font-family: Manrope;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;
  color: #000000;
}

.heading_text2 {
  font-family: Lexend;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #263238;
}

.content_text2 {
  font-family: Lexend;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  color: #263238;
}

.content_text3 {
  font-family: Lexend;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: #263238;
}

.content_text4 {
  font-family: Manrope;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: #78789D;

}

/* contact fields  */

.contactinput_placeholder {
  padding: 0.5rem;
  pointer-events: none;
  position: absolute;
  left: -0.5rem;
  top: 0rem;
  transition: 0.4s;
  opacity: 1;
  font-family: Lexend;
  font-size: 16px;
  font-weight: 300;
  line-height: 13.75px;
  text-align: left;
  color: #000000;

}

.contact_fields:focus,
.contact_fields:not(:placeholder-shown) {
  outline: none;
  border-top: none;
  border-right: none;
  border-left: none;
}

.contact_fields:focus+.contactinput_placeholder,
.contact_fields:not(:placeholder-shown)+.contactinput_placeholder {
  opacity: 1;
  color: #1b9075;
  transform: scale(0.75) translateY(-65%) translateX(-20px);
}

/* contact first name */
.contact_fields:focus+.contactinput_placeholder_fn,
.contact_fields:not(:placeholder-shown)+.contactinput_placeholder_fn {
  opacity: 1;
  color: #1b9075;
  transform: scale(0.75) translateY(-65%) translateX(-5px);
}

/* contact last name */
.contact_fields:focus+.contactinput_placeholder_ln,
.contact_fields:not(:placeholder-shown)+.contactinput_placeholder_ln {
  opacity: 1;
  color: #1b9075;
  transform: scale(0.75) translateY(-65%) translateX(-5px);
}

/* contact mobile */
.contact_fields:focus+.contactinput_placeholder_mobile,
.contact_fields:not(:placeholder-shown)+.contactinput_placeholder_mobile {
  opacity: 1;
  color: #1b9075;
  transform: scale(0.75) translateY(-65%) translateX(-8px);
}

/* contact email */
.contact_fields:focus+.contactinput_placeholder_email,
.contact_fields:not(:placeholder-shown)+.contactinput_placeholder_email {
  opacity: 1;
  color: #1b9075;
  transform: scale(0.75) translateY(-65%) translateX(2px);
}

/* contact message */
.contact_fields:focus+.contactinput_placeholder_message,
.contact_fields:not(:placeholder-shown)+.contactinput_placeholder_message {
  opacity: 1;
  color: #1b9075;
  transform: scale(0.75) translateY(-65%) translateX(-10px);
}

/* old password */
input:focus+.input_placeholder_op,
input:not(:placeholder-shown)+.input_placeholder_op {
  opacity: 1;
  color: #1b9075;
  transform: scale(0.75) translateY(-65%) translateX(-25px);
}

/* new password */
input:focus+.input_placeholder_np,
input:not(:placeholder-shown)+.input_placeholder_np {
  opacity: 1;
  color: #1b9075;
  transform: scale(0.75) translateY(-65%) translateX(-28px);
}

/* confirm password */
input:focus+.input_placeholder_cp,
input:not(:placeholder-shown)+.input_placeholder_cp {
  opacity: 1;
  color: #1b9075;
  transform: scale(0.75) translateY(-65%) translateX(-32px);
}

/* coupon code */
input:focus+.input_placeholder_coupon,
input:not(:placeholder-shown)+.input_placeholder_coupon {
  opacity: 1;
  color: #1b9075;
  transform: scale(0.75) translateY(-65%) translateX(-40px);
}

/* profile phone */
input:focus+.input_placeholder_profilephone,
input:not(:placeholder-shown)+.input_placeholder_profilephone {
  opacity: 1;
  color: #1b9075;
  transform: scale(0.75) translateY(-65%) translateX(-28px);
}

.contact_fields {
  border-bottom: 1px solid #A2A2A2;
}

.contact_fields:focus {
  border-color: transparent;
  border: none;
  box-shadow: 0 0 0 0 !important;
  border-bottom: 1px solid #1B9075;
}

.textarea {
  border-bottom: 1px solid #A2A2A2;
  box-shadow: 0 0 0 0 !important;
}

.textarea:focus {
  border-color: transparent;
  border: none;
  box-shadow: 0 0 0 0 !important;
  border-bottom: 1px solid #1B9075;
}


/* blogs */

.blogheading {
  font-family: Manrope;
  font-size: 24px;
  font-weight: 700;
  line-height: 32.78px;
  text-align: center;
  color: #1b1b1b;
}

/* progress bar */

.pheight {
  height: 0.05rem;
}

.ptop {
  top: -0.5rem;
}

.bgStep {
  background-color: #1B9075;
}

.activeP {
  background-color: #1B9075;
}

/* for 0 left padding */
.paddingLeft {
  padding-left: 0rem !important;
}


.locationDetails {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -100%);
  background-color: #fff;
  padding: 5px 10px;
  width: auto;
  height: auto;
  border-radius: 50px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
  white-space: nowrap
}


/* .container {
  max-width: 100%;
} */

/* .container {
  padding-left: 0rem !important;
  padding-right: 0rem !important;
} */

/* Mobile-friendly styles (default for smaller screens) */
.container-fluid {
  padding-left: 15px; /* Padding for mobile */
  padding-right: 15px;
}

/* Desktop-specific styles */
@media (min-width: 992px) { /* Adjust 992px to your breakpoint for desktop */
  .container-fluid {
    padding-left: 80px !important; /* Increased padding for desktop */
    padding-right: 80px !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/common.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;;AAGA,gCAAgC;;AAEhC;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;;EAEE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;;EAEE,UAAU;EACV,cAAc;EACd,yDAAyD;AAC3D;;AAEA,mBAAmB;AACnB;;EAEE,yDAAyD;AAC3D;;AAEA,sBAAsB;AACtB;;EAEE,yDAAyD;AAC3D;;;AAGA,mBAAmB;AACnB;;EAEE,yDAAyD;AAC3D;;AAEA,2BAA2B;AAC3B;;EAEE,yDAAyD;AAC3D;;AAEA,uBAAuB;AACvB;;EAEE,yDAAyD;AAC3D;;AAEA,0BAA0B;AAC1B;;EAEE,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;;EAEnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA,yDAAyD;;AAEzD;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA,oBAAoB;;AAEpB;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;EACV,cAAc;EACd,yDAAyD;AAC3D;;AAEA,uBAAuB;AACvB;;EAEE,UAAU;EACV,cAAc;EACd,wDAAwD;AAC1D;;AAEA,sBAAsB;AACtB;;EAEE,UAAU;EACV,cAAc;EACd,wDAAwD;AAC1D;;AAEA,mBAAmB;AACnB;;EAEE,UAAU;EACV,cAAc;EACd,wDAAwD;AAC1D;;AAEA,kBAAkB;AAClB;;EAEE,UAAU;EACV,cAAc;EACd,uDAAuD;AACzD;;AAEA,oBAAoB;AACpB;;EAEE,UAAU;EACV,cAAc;EACd,yDAAyD;AAC3D;;AAEA,iBAAiB;AACjB;;EAEE,UAAU;EACV,cAAc;EACd,yDAAyD;AAC3D;;AAEA,iBAAiB;AACjB;;EAEE,UAAU;EACV,cAAc;EACd,yDAAyD;AAC3D;;AAEA,qBAAqB;AACrB;;EAEE,UAAU;EACV,cAAc;EACd,yDAAyD;AAC3D;;AAEA,gBAAgB;AAChB;;EAEE,UAAU;EACV,cAAc;EACd,yDAAyD;AAC3D;;AAEA,kBAAkB;AAClB;;EAEE,UAAU;EACV,cAAc;EACd,yDAAyD;AAC3D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;EAC9B,gCAAgC;AAClC;;;AAGA,UAAU;;AAEV;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB;;AAEjB;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;AAC/B;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C;AACF;;;AAGA;;GAEG;;AAEH;;;GAGG;;AAEH,yDAAyD;AACzD;EACE,kBAAkB,EAAE,uBAAuB;EAC3C,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B,4BAA4B,gDAAgD;EAC1E;IACE,6BAA6B,EAAE,kCAAkC;IACjE,8BAA8B;EAChC;AACF","sourcesContent":[".company_logo {\n  width: 190px;\n  height: 44px;\n  gap: 0px;\n  opacity: 1 !important;\n}\n\n.cursor_pointer {\n  cursor: pointer;\n}\n\n.navbar_bg {\n  background-color: #f7f7f7;\n}\n\n.bg_button_color {\n  background: #1b9075;\n}\n\n.disabled_button {\n  background: #c3c7ca;\n}\n\n.text_color {\n  color: #1b9075;\n}\n\n.p_info {\n  width: 297px;\n  height: 44px;\n  gap: 0px;\n  font-family: Lexend;\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 22px;\n  text-align: center;\n  margin: 0 auto;\n  opacity: 1 !important;\n}\n\ninput:focus {\n  border-color: transparent;\n  border: none;\n  box-shadow: 0 0 0 1px #1b9075 !important;\n}\n\ntextarea {\n  border-color: transparent;\n  border: none;\n  box-shadow: 0 0 0 1px #1b9075 !important;\n}\n\n.marginTopNeg_8 {\n  margin-top: -8rem;\n}\n\n.marginTopNeg_5 {\n  margin-top: -3rem;\n}\n\n.mobile_code {\n  height: 15rem;\n  transform: translate(0px, 146px) !important;\n  overflow: auto;\n  position: absolute;\n  width: 28%;\n}\n\n.mobile_code_list .active {\n  background-color: #1b9075;\n}\n\n.mobile_code_list .active span {\n  color: #fff;\n}\n\n.mobile_code_list li:hover {\n  background-color: #1b9075;\n}\n\n.mobile_code_list li button:hover {\n  color: #fff;\n}\n\n.form_error {\n  color: #f32013;\n  font-family: Manrope;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0 0.25rem;\n}\n\n.form_error_border {\n  border: 1px solid #f32013;\n}\n\n.form_error_border_input {\n  border: 1px solid #f32013;\n  border-left: 0px !important;\n}\n\n.form_error_border_code {\n  border: 1px solid #f32013;\n  border-right: 0px !important;\n}\n\n\n/* common css for input fields */\n\n.input_field {\n  /* width: 350px;*/\n  height: 58px;\n  border-radius: 5px;\n  /* border: 1px solid #1B9075; */\n}\n\n.input_placeholder {\n  /* padding: 0.5rem; */\n  padding-top: 0.5rem;\n  padding-right: 0.75rem;\n  padding-bottom: 0.5rem;\n  padding-left: 0.75rem;\n  pointer-events: none;\n  position: absolute;\n  left: 0.5rem;\n  top: 1rem;\n  transition: 0.4s;\n  opacity: 1;\n  font-family: Lexend;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 13.75px;\n  text-align: left;\n  color: #a1a8a6;\n\n}\n\ninput:focus,\ninput:not(:placeholder-shown) {\n  outline: none;\n  /* border-color: #1b9075; */\n}\n\ninput:focus+.input_placeholder,\ninput:not(:placeholder-shown)+.input_placeholder {\n  opacity: 1;\n  color: #1b9075;\n  transform: scale(0.75) translateY(-65%) translateX(-20px);\n}\n\n/* for input note */\ninput:focus+.input_placeholder_note,\ninput:not(:placeholder-shown)+.input_placeholder_note {\n  transform: scale(0.75) translateY(-65%) translateX(-40px);\n}\n\n/* for input service */\ninput:focus+.input_placeholder_servicetype,\ninput:not(:placeholder-shown)+.input_placeholder_servicetype {\n  transform: scale(0.75) translateY(-65%) translateX(-24px);\n}\n\n\n/* for input area */\ninput:focus+.input_placeholder_area,\ninput:not(:placeholder-shown)+.input_placeholder_area {\n  transform: scale(0.75) translateY(-65%) translateX(-38px);\n}\n\n/* for input house number */\ninput:focus+.input_placeholder_houseNumber,\ninput:not(:placeholder-shown)+.input_placeholder_houseNumber {\n  transform: scale(0.75) translateY(-65%) translateX(-30px);\n}\n\n/* for input location */\ninput:focus+.input_placeholder_location,\ninput:not(:placeholder-shown)+.input_placeholder_location {\n  transform: scale(0.75) translateY(-65%) translateX(-32px);\n}\n\n/* for input addresstype */\ninput:focus+.input_placeholder_addresstype,\ninput:not(:placeholder-shown)+.input_placeholder_addresstype {\n  transform: scale(0.75) translateY(-65%) translateX(-26px);\n}\n\n.btn_primary {\n  width: 100%;\n  height: auto;\n  border-radius: 9px;\n  background: #1B9075;\n  color: #fff;\n  padding: 1rem;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 24px;\n  text-align: center;\n}\n\n.btn_secondary {\n  width: 100%;\n  height: auto;\n  border-radius: 9px;\n  background: #E4EFEC;\n  color: #1B9075;\n  padding: 1rem;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 24px;\n  text-align: center;\n}\n\n.btn_light {\n  border: 1px solid #1B9075;\n  width: auto;\n  height: auto;\n  padding: 6px 14px 6px 14px;\n  border-radius: 10px;\n\n  font-family: Lexend;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  text-align: left;\n  color: #1B9075;\n  background-color: #fff;\n}\n\n.first_head {\n  font-family: Manrope;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 32.78px;\n  text-align: left;\n}\n\n.second_head {\n  font-family: Manrope;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 32.78px;\n  text-align: left;\n  color: #1B9075;\n}\n\n.addAddressBtnTxt {\n  font-family: Manrope;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 32.78px;\n  text-align: left;\n  color: #1B9075;\n}\n\ninput[type=\"date\"] {\n  position: relative;\n  background-repeat: no-repeat;\n  background-position: right 2.75rem center;\n  background-size: 16px 12px;\n}\n\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n  background: transparent;\n  bottom: 0;\n  color: transparent;\n  cursor: pointer;\n  height: auto;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n}\n\ninput[type=\"date\"]::after {\n  position: absolute;\n  right: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  width: 16px;\n  height: 16px;\n}\n\n/* css for about us contact us and blog and other pages */\n\n.bgColor {\n  background: #1B9075;\n}\n\n.heading_text {\n  font-family: Manrope;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32.78px;\n  /* text-align: left; */\n  color: #ffffff;\n}\n\n.content_text {\n  font-family: Manrope;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 28px;\n  text-align: left;\n  color: #263238;\n}\n\n.heading_text1 {\n  font-family: Manrope;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 28px;\n  text-align: left;\n  color: #1B9075;\n}\n\n.content_text1 {\n  font-family: Manrope;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 28px;\n  text-align: left;\n  color: #000000;\n}\n\n.heading_text2 {\n  font-family: Lexend;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: left;\n  color: #263238;\n}\n\n.content_text2 {\n  font-family: Lexend;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 24px;\n  text-align: center;\n  color: #263238;\n}\n\n.content_text3 {\n  font-family: Lexend;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n  text-align: left;\n  color: #263238;\n}\n\n.content_text4 {\n  font-family: Manrope;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 18px;\n  text-align: left;\n  color: #78789D;\n\n}\n\n/* contact fields  */\n\n.contactinput_placeholder {\n  padding: 0.5rem;\n  pointer-events: none;\n  position: absolute;\n  left: -0.5rem;\n  top: 0rem;\n  transition: 0.4s;\n  opacity: 1;\n  font-family: Lexend;\n  font-size: 16px;\n  font-weight: 300;\n  line-height: 13.75px;\n  text-align: left;\n  color: #000000;\n\n}\n\n.contact_fields:focus,\n.contact_fields:not(:placeholder-shown) {\n  outline: none;\n  border-top: none;\n  border-right: none;\n  border-left: none;\n}\n\n.contact_fields:focus+.contactinput_placeholder,\n.contact_fields:not(:placeholder-shown)+.contactinput_placeholder {\n  opacity: 1;\n  color: #1b9075;\n  transform: scale(0.75) translateY(-65%) translateX(-20px);\n}\n\n/* contact first name */\n.contact_fields:focus+.contactinput_placeholder_fn,\n.contact_fields:not(:placeholder-shown)+.contactinput_placeholder_fn {\n  opacity: 1;\n  color: #1b9075;\n  transform: scale(0.75) translateY(-65%) translateX(-5px);\n}\n\n/* contact last name */\n.contact_fields:focus+.contactinput_placeholder_ln,\n.contact_fields:not(:placeholder-shown)+.contactinput_placeholder_ln {\n  opacity: 1;\n  color: #1b9075;\n  transform: scale(0.75) translateY(-65%) translateX(-5px);\n}\n\n/* contact mobile */\n.contact_fields:focus+.contactinput_placeholder_mobile,\n.contact_fields:not(:placeholder-shown)+.contactinput_placeholder_mobile {\n  opacity: 1;\n  color: #1b9075;\n  transform: scale(0.75) translateY(-65%) translateX(-8px);\n}\n\n/* contact email */\n.contact_fields:focus+.contactinput_placeholder_email,\n.contact_fields:not(:placeholder-shown)+.contactinput_placeholder_email {\n  opacity: 1;\n  color: #1b9075;\n  transform: scale(0.75) translateY(-65%) translateX(2px);\n}\n\n/* contact message */\n.contact_fields:focus+.contactinput_placeholder_message,\n.contact_fields:not(:placeholder-shown)+.contactinput_placeholder_message {\n  opacity: 1;\n  color: #1b9075;\n  transform: scale(0.75) translateY(-65%) translateX(-10px);\n}\n\n/* old password */\ninput:focus+.input_placeholder_op,\ninput:not(:placeholder-shown)+.input_placeholder_op {\n  opacity: 1;\n  color: #1b9075;\n  transform: scale(0.75) translateY(-65%) translateX(-25px);\n}\n\n/* new password */\ninput:focus+.input_placeholder_np,\ninput:not(:placeholder-shown)+.input_placeholder_np {\n  opacity: 1;\n  color: #1b9075;\n  transform: scale(0.75) translateY(-65%) translateX(-28px);\n}\n\n/* confirm password */\ninput:focus+.input_placeholder_cp,\ninput:not(:placeholder-shown)+.input_placeholder_cp {\n  opacity: 1;\n  color: #1b9075;\n  transform: scale(0.75) translateY(-65%) translateX(-32px);\n}\n\n/* coupon code */\ninput:focus+.input_placeholder_coupon,\ninput:not(:placeholder-shown)+.input_placeholder_coupon {\n  opacity: 1;\n  color: #1b9075;\n  transform: scale(0.75) translateY(-65%) translateX(-40px);\n}\n\n/* profile phone */\ninput:focus+.input_placeholder_profilephone,\ninput:not(:placeholder-shown)+.input_placeholder_profilephone {\n  opacity: 1;\n  color: #1b9075;\n  transform: scale(0.75) translateY(-65%) translateX(-28px);\n}\n\n.contact_fields {\n  border-bottom: 1px solid #A2A2A2;\n}\n\n.contact_fields:focus {\n  border-color: transparent;\n  border: none;\n  box-shadow: 0 0 0 0 !important;\n  border-bottom: 1px solid #1B9075;\n}\n\n.textarea {\n  border-bottom: 1px solid #A2A2A2;\n  box-shadow: 0 0 0 0 !important;\n}\n\n.textarea:focus {\n  border-color: transparent;\n  border: none;\n  box-shadow: 0 0 0 0 !important;\n  border-bottom: 1px solid #1B9075;\n}\n\n\n/* blogs */\n\n.blogheading {\n  font-family: Manrope;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32.78px;\n  text-align: center;\n  color: #1b1b1b;\n}\n\n/* progress bar */\n\n.pheight {\n  height: 0.05rem;\n}\n\n.ptop {\n  top: -0.5rem;\n}\n\n.bgStep {\n  background-color: #1B9075;\n}\n\n.activeP {\n  background-color: #1B9075;\n}\n\n/* for 0 left padding */\n.paddingLeft {\n  padding-left: 0rem !important;\n}\n\n\n.locationDetails {\n  position: absolute;\n  top: 40%;\n  left: 50%;\n  transform: translate(-50%, -100%);\n  background-color: #fff;\n  padding: 5px 10px;\n  width: auto;\n  height: auto;\n  border-radius: 50px;\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);\n  white-space: nowrap\n}\n\n\n/* .container {\n  max-width: 100%;\n} */\n\n/* .container {\n  padding-left: 0rem !important;\n  padding-right: 0rem !important;\n} */\n\n/* Mobile-friendly styles (default for smaller screens) */\n.container-fluid {\n  padding-left: 15px; /* Padding for mobile */\n  padding-right: 15px;\n}\n\n/* Desktop-specific styles */\n@media (min-width: 992px) { /* Adjust 992px to your breakpoint for desktop */\n  .container-fluid {\n    padding-left: 80px !important; /* Increased padding for desktop */\n    padding-right: 80px !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
